import { SupportBanner } from '@/components/support-banner'

export const SupportSection = () => {
  return <SupportBanner />
}
